/*
 * サブシステム名：XXXX
 * 機能名：車両経費一覧
 */
import { mapGetters } from 'vuex'
import flowMixin from '@/mixins/flowMixins'
import filter from '@/rahmen/utils/filters'
import validators from '@/rahmen/validators'

const DdSearchList = () => import('@/components/DdSearchList')
const DdDateRangeBox = () => import('@/components/DdDateRangeBox')
const DdRadioButton = () => import('@/components/DdRadioButton')
const DdTextBox = () => import('../../components/DdTextBox.vue')

export default {
  name: 'PrmSharyoKeihiList',
  mixins: [flowMixin],
  components: {
    DdSearchList,
    DdTextBox,
    DdDateRangeBox,
    DdRadioButton
  },
  data: () => ({
    // 一覧制御用
    selected: [],
    itemsPerPage: 100,
    page: 1,

    conditions: {
      hasseiStartYmdString: '',
      hasseiEndYmdString: '',
      keijoStartYmdString: '',
      keijoEndYmdString: '',
      sharyoKeihiNo: '',
      jissekiKakuninZumiFlgKbn: null,
      jissekiShimeFlgKbn: null,
      hasseiYmdFromTo: null,
      keijoYmdFromTo: null,
      jissekiKakuninZumiFlgKbnNm: null,
      jissekiShimeFlgKbnNm: null
    },
    conditionDetails: [
      { key: 'hasseiYmdFromTo', name: '発生年月日', value: 'hasseiYmdFromTo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'keijoYmdFromTo', name: '計上年月日', value: 'keijoYmdFromTo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'sharyoKeihiNo', name: '車両経費No', value: 'sharyoKeihiNo', type: 'value', delete: true, showValue: true, convertValue: false },
      { key: 'jissekiKakuninZumiFlgKbnNm', name: '実績確認状況', value: 'jissekiKakuninZumiFlgKbnNm', type: 'value', delete: false, showValue: true, convertValue: false },
      { key: 'jissekiShimeFlgKbnNm', name: '実績締状況', value: 'jissekiShimeFlgKbnNm', type: 'value', delete: false, showValue: true, convertValue: false }
    ],
    modeKengen: 0
  }),
  watch: {
    /**
     * 検索条件簡易表示用
     * @param {} n
     */
    // 発生年月日
    'conditions.hasseiStartYmdString': function (n) {
      var hasseiYmdFromTo = ![undefined, null, ''].includes(this.conditions.hasseiStartYmdString) ? this.conditions.hasseiStartYmdString.slice(-5) : ''
      hasseiYmdFromTo = hasseiYmdFromTo + (![undefined, null, ''].includes(this.conditions.hasseiEndYmdString) ? '～' + this.conditions.hasseiEndYmdString.slice(-5) : '')
      this.conditions.hasseiYmdFromTo = hasseiYmdFromTo
    },
    'conditions.hasseiEndYmdString': function (n) {
      var hasseiYmdFromTo = ![undefined, null, ''].includes(this.conditions.hasseiStartYmdString) ? this.conditions.hasseiStartYmdString.slice(-5) : ''
      hasseiYmdFromTo = hasseiYmdFromTo + (![undefined, null, ''].includes(this.conditions.hasseiEndYmdString) ? '～' + this.conditions.hasseiEndYmdString.slice(-5) : '')
      this.conditions.hasseiYmdFromTo = hasseiYmdFromTo
    },
    // 計上年月日
    'conditions.keijoStartYmdString': function (n) {
      var keijoYmdFromTo = ![undefined, null, ''].includes(this.conditions.keijoStartYmdString) ? this.conditions.keijoStartYmdString.slice(-5) : ''
      keijoYmdFromTo = keijoYmdFromTo + (![undefined, null, ''].includes(this.conditions.keijoEndYmdString) ? '～' + this.conditions.keijoEndYmdString.slice(-5) : '')
      this.conditions.keijoYmdFromTo = keijoYmdFromTo
    },
    'conditions.keijoEndYmdString': function (n) {
      var keijoYmdFromTo = ![undefined, null, ''].includes(this.conditions.keijoStartYmdString) ? this.conditions.keijoStartYmdString.slice(-5) : ''
      keijoYmdFromTo = keijoYmdFromTo + (![undefined, null, ''].includes(this.conditions.keijoEndYmdString) ? '～' + this.conditions.keijoEndYmdString.slice(-5) : '')
      this.conditions.keijoYmdFromTo = keijoYmdFromTo
    },
    // 実績登録状況
    'conditions.jissekiKakuninZumiFlgKbn': function (n) {
      this.conditions.jissekiKakuninZumiFlgKbnNm = this.conditions.jissekiKakuninZumiFlgKbn === '1' ? '済' : this.conditions.jissekiKakuninZumiFlgKbn === '0' ? '未' : '全て'
    },
    // 実績確認状況
    'conditions.jissekiShimeFlgKbn': function (n) {
      this.conditions.jissekiShimeFlgKbnNm = this.conditions.jissekiShimeFlgKbn === '1' ? '済' : this.conditions.jissekiShimeFlgKbn === '0' ? '未' : '全て'
    }
  },
  computed: {
    ...mapGetters({
      viewTitle: 'system/viewTitle',
      helpUseFlg: 'DDMasters/helpUseFlg'
    }),
    filteredRows () {
      console.log('filter', this.rows)
      return this.rows.map((elem) => {
        elem.hasseiYmdDisp = elem.hasseiYmd ? filter.dateFormatter(elem.hasseiYmd) : ''
        elem.keijoYmdDisp = elem.keijoYmd ? filter.dateFormatter(elem.keijoYmd) : ''
        elem.suryoDisp = elem.suryo === 0 || elem.suryo ? filter.numericFormatter(elem.suryo) : ''
        elem.keihiTankaDisp = elem.keihiTanka === 0 || elem.keihiTanka ? filter.numericFormatter(elem.keihiTanka) : ''
        elem.keihiKingakuDisp = elem.keihiKingaku === 0 || elem.keihiKingaku ? filter.numericFormatter(elem.keihiKingaku) : ''
        elem.odoMaterDisp = elem.odoMater === 0 || elem.odoMater ? filter.numericMinorDigitFormatter(elem.odoMater, 1) : ''
        return elem
      })
    },
    isCsvButtonDisabled () {
      return this.rows.length === 0
    },
    isAddButtonDisplay () {
      if (this.modeKengen === 0) {
        return false
      }
      return true
    }
  },
  created () {
  },
  mounted () {
    this.initialize()
  },
  beforeRouteUpdate (to, from, next) {
    this.$refs.initialize()
    next()
  },
  methods: {
    getCloneTargetMethod: function () {
      return {
        rows: this.rows,
        conditions: this.conditions,
        searchText: this.searchText
      }
    },
    initialize: function () {
      const self = this
      const opt = {
        defineHeaderPromise: () => {
          return new Promise(resolve => {
            console.log('PrmSharyoKeihiList.defineHeaderPromise')
            self.headers = [
              { text: '編集', value: 'actions', sortable: false, width: '20px' },
              { text: '車両経費No', value: 'sharyoKeihiNo' },
              { text: '発生年月日', value: 'hasseiYmdDisp', align: 'center' },
              { text: '計上年月日', value: 'keijoYmdDisp', align: 'center' },
              { text: '実績確認済み', value: 'jissekiKakuninZumiFlgDisp' },
              { text: '実績締', value: 'jissekiShimeFlgDisp' },
              { text: '取引先', value: 'torihikisakiNm' },
              { text: '入力担当者', value: 'nyuryokuTantoshaNm' },
              { text: '経費営業所', value: 'keihiEigyoshoNm' },
              { text: '経費部門', value: 'keihiBumonNm' },
              { text: '車両整備経費区分', value: 'sharyoSeibiKeihiKbnNm' },
              { text: '数量', value: 'suryoDisp', align: 'right' },
              { text: '車両整備単位区分', value: 'sharyoSeibiTaniKbnNm' },
              { text: '経費単価', value: 'keihiTankaDisp', align: 'right' },
              { text: '経費金額', value: 'keihiKingakuDisp', align: 'right' },
              { text: '摘要1', value: 'tekiyo1' },
              { text: '摘要2', value: 'tekiyo2' },
              { text: '摘要3', value: 'tekiyo3' },
              { text: '摘要4', value: 'tekiyo4' },
              { text: '摘要5', value: 'tekiyo5' },
              { text: '社内備考', value: 'shanaiBiko' },
              { text: '車両表示名', value: 'mstSharyoNm' },
              { text: '自動車登録番号', value: 'torokuNo' },
              { text: 'オドメータ', value: 'odoMaterDisp', align: 'right' }
            ]
            resolve()
          })
        },
        initializeInputPromise: function () {
          return new Promise((resolve) => {
            self.conditions = {
              hasseiStartYmdString: '',
              hasseiEndYmdString: '',
              keijoStartYmdString: '',
              keijoEndYmdString: '',
              sharyoKeihiNo: '',
              jissekiKakuninZumiFlgKbn: '9',
              jissekiShimeFlgKbn: '9',
              hasseiYmdFromTo: null,
              keijoYmdFromTo: null,
              jissekiKakuninZumiFlgKbnNm: null,
              jissekiShimeFlgKbnNm: null
            }
            resolve()
          })
        },
        savedInputRestorePromise: (c) => {
          console.log('PrmSharyoKeihiList.savedInputRestorePromise', c)
          // ユーザ保存項目の復元
          self.conditions = { ...self.conditions, ...c }
          return new Promise(resolve => {
            self.loadFromCache()
              .then((c) => {
                console.log('PrmSharyoKeihiList.savedInputRestorePromise', c)
                resolve()
              })
          })
        },
        researchPromise: (c) => {
          console.log('PrmSharyoKeihiList.researchPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.onSearchButtonClick()
            resolve()
            // self.search().then(() => {
            //   resolve()
            // })
          })
        },
        restoreViewPromise: (c) => {
          console.log('PrmSharyoKeihiList.restoreViewPromise', c)
          return new Promise(resolve => {
            self.conditions = c.cache.value ? c.cache.value.conditions || {} : self.conditions
            self.searchText = c.cache.value ? c.cache.value.searchText || '' : self.searchText
            self.rows = c.cache.value ? c.cache.value.rows || [] : self.rows
            resolve()
          })
        },
        settingButtonStatePromise: (kengen) => {
          console.log('PrmSharyoKeihiList.settingButtonStatePromise', kengen)
          return new Promise(resolve => {
            console.log('settingButtonStatePromise', kengen)
            if (kengen.kengenKbn === '10') {
              // 読取モード
              self.modeKengen = 0
            } else if (kengen.kengenKbn === '20') {
              // 削除不可モード
              self.modeKengen = 1
            } else {
              // フルアクセス
              self.modeKengen = 2
            }

            this.$nextTick(() => {
              document.getElementById('heavy-element').style.display = ''
            })

            resolve()
          })
        }
      }
      this.initializeForViewer(opt)
    },
    onSearchButtonClick: function (e) {
      // 選択状態初期化
      this.selected = []
      this.page = 1

      const self = this
      const opt = {
        searchRequestPromise: function () {
          return new Promise(resolve => {
            self.HttpClient.post('/api/v1/VwCD2prmd2010/search', self.conditions)
              .then((data) => {
                resolve(data)
              })
          })
        },
        searchResultMethod: function (data) {
          self.rows = data.payload
          const cache = {
            rows: self.rows,
            conditions: self.conditions,
            searchText: self.searchText
          }
          self.saveToChache(cache)
        },
        getSavedInputMethod: function () {
          return {}
        }
      }
      this.search(opt)
    },

    clear: function () {
      console.log('clear pushed')
      const self = this
      const opt = {
        clearInputsPromise: () => {
          return new Promise(resolve => {
            self.conditions = {
              hasseiStartYmdString: '',
              hasseiEndYmdString: '',
              keijoStartYmdString: '',
              keijoEndYmdString: '',
              sharyoKeihiNo: '',
              jissekiKakuninZumiFlgKbn: '9',
              jissekiShimeFlgKbn: '9',
              hasseiYmdFromTo: null,
              keijoYmdFromTo: null,
              jissekiKakuninZumiFlgKbnNm: null,
              jissekiShimeFlgKbnNm: null
            }
            self.searchText = ''
            this.rows = []
            self.selected = []
            self.page = 1
            resolve()
          })
        }
      }
      this.clearInputs(opt)
    },
    onClearButtonClick: function (e) {
      console.log('clear pushed')
      this.Effects.loadStart()
      this.clear()
    },
    onRowDoubleClick: function (e, f) {
      console.log(e, f)
      this.Effects.loadStart()
      this.transition(0, { id: f.item.id })
    },
    onRowEditButtonClick: function (item) {
      // 画面遷移
      this.Effects.loadStart()
      this.transition(0, { id: item.id })
    },
    onCreateButtonClick: function (e) {
      console.log(e)
      this.Effects.loadStart()
      this.transition(0, { id: 0 })
    },
    searchValidate: function () {
      if (this.conditions.hasseiStartYmdString && this.conditions.hasseiEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.hasseiStartYmdString, this.conditions.hasseiEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.hasseiStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.hasseiEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      if (this.conditions.keijoStartYmdString && this.conditions.keijoEndYmdString) {
        const msg1 = validators.compareDate(this.conditions.keijoStartYmdString, this.conditions.keijoEndYmdString)
        if (msg1 !== undefined) {
          this.$refs.keijoStartYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.$refs.keijoEndYmdString[this.Ctrls.SET_INVALID_METHOD](msg1)
          this.setInvalidSummaryMessage('COME0014')
          return false
        }
      }
      return true
    }
  }
}
